import { URI } from '@/config/config';

export default async ({ rootState }, { data, pointOfInterestId }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${URI}points-of-interest/${pointOfInterestId}`,
    opts,
  );
  const jsonResult = await response.json();

  return jsonResult;
};
